import Vue from 'vue';
import VTooltip from 'v-tooltip';
import VHover from 'v-hover';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';
import helper from './helper';
/* eslint-disable no-unused-vars */
import {
  gsap, TimelineMax, Power4, TweenMax, Power2, Back,
} from 'gsap/dist/gsap';
/* eslint-enable no-unused-vars */
Vue.use(VTooltip);
Vue.use(VHover);
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');

router.beforeEach((to, from, next) => {
  if (!helper.isMobile()) {
    if (to.name !== from.name && from.name) {
      const tl = new TimelineMax({ onComplete: next });
      tl.fromTo('.reddot', 1, { scale: 1, transformOrigin: '50% 50%' }, { scale: 300, transformOrigin: '50% 50%', ease: Power2.easeIn, force3D: false });
      //tl.fromTo('.outerwrapper', 0.5, { opacity: 1 }, { opacity: 0 });
    }
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  if (from.name !== to.name && from.name && !helper.isMobile()) {
    const tl = new TimelineMax();
    tl.fromTo('.reddot', 1, { scale: 300, transformOrigin: '50% 50%' }, { scale: 1, transformOrigin: '50% 50%', ease: Power2.easeOut, force3D: false }, '+=0.2');
    //tl.fromTo('.outerwrapper', 0.5, { opacity: 0 }, { opacity: 1 });
    // TODO put outerwrapper in mounted hook
  }
});
